/**
 * @generated SignedSource<<8eef283bd996bb8dfa7514a8d3821b81>>
 * @relayHash 5c6642ee38b891b2c2af86d9ea1e50c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03dd87e2390669bb0cd5f65a8e5dad130cc98433fdb1208dea658cfc0fc7f7c2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getPeopleProps_suggestedGroupsQuery$variables = {
  cloudId: string;
  includeAppTypeForJqlBuilder: boolean;
  suggestedUsersCount?: number | null | undefined;
};
export type getPeopleProps_suggestedGroupsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedUsers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly user: {
              readonly appType?: string | null | undefined;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly suggestedGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
  readonly me: {
    readonly user: {
      readonly picture: AGG$URL;
    } | null | undefined;
  };
};
export type getPeopleProps_suggestedGroupsQuery = {
  response: getPeopleProps_suggestedGroupsQuery$data;
  variables: getPeopleProps_suggestedGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAppTypeForJqlBuilder"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suggestedUsersCount"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "suggestedUsersCount"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "condition": "includeAppTypeForJqlBuilder",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appType"
        }
      ]
    }
  ],
  "type": "AppUser"
},
v9 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 5
    }
  ],
  "concreteType": "JiraJqlGroupFieldValueConnection",
  "kind": "LinkedField",
  "name": "suggestedGroups",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraJqlGroupFieldValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraJqlGroupFieldValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v7/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "suggestedGroups(first:5)"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getPeopleProps_suggestedGroupsQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v4/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v5/*: any*/),
                  "concreteType": "JiraJqlUserFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedUsers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlUserFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlUserFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v6/*: any*/),
                            (v7/*: any*/),
                            {
                              "kind": "LinkedField",
                              "name": "user",
                              "plural": false,
                              "selections": [
                                (v3/*: any*/),
                                (v8/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                (v9/*: any*/)
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "getPeopleProps_suggestedGroupsQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v3/*: any*/),
              (v11/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraJqlUserFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedUsers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlUserFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlUserFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v3/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "03dd87e2390669bb0cd5f65a8e5dad130cc98433fdb1208dea658cfc0fc7f7c2",
    "metadata": {},
    "name": "getPeopleProps_suggestedGroupsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fedf4ed4dd8473de7eddc5189955194e";

export default node;
